import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect, useSelector } from "react-redux";
import JobRoleForm from "./JobRoleForm";
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import { 
	getJobRoleList, 
	doJobRoleDelete,
} from "../../../../redux/jobrole/jobRoleState";
import { MODULE_JOBROLES } from "variables/constants";
import { useCRUDAccess } from "utils/useCRUDAccess";


const JobRoleTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {
	const checkCRUDAccess = useCRUDAccess();
	const accessRights = checkCRUDAccess(MODULE_JOBROLES, ['view', 'add', 'edit', 'delete'], true);
	const authUser = useSelector((state) => state.auth.user);

  	const columns = [
		{
	        title: `Job Title`,
	        dataIndex: 'jro_job_title',
	        key: 'jro_job_title',
	        width: '35%',
	        render:(jro_job_title) => <span>{jro_job_title}</span> 
	    },
		{
	        title: `Requested by`,
	        dataIndex: 'created_by',
	        key: 'created_by',
	        width: '15%',
	        render:(created_by) => <span>{created_by}</span> 
	    },
		{
	        title: `Count`,
	        dataIndex: 'jro_count',
	        key: 'jro_count',
	        width: '8%',
	        render:(jro_count) => <span>{jro_count}</span> 
	    },
		{
	        title: `Status`,
	        dataIndex: 'job_role_status_name',
	        key: 'job_role_status_name',
	        width: '10%',
	        render:(job_role_status_name) => <span>{job_role_status_name}</span> 
	    },
		{
	        title: `Location`,
	        dataIndex: 'jro_location',
	        key: 'jro_location',
	        width: '20%',
	        render:(jro_location) => <span>{jro_location}</span> 
	    },
		
	    {
	        title: <PopupButton id="add_job_role" title="Add Job Role" label="Add" btnClass="btn-small" moduleId={MODULE_JOBROLES}>
						<JobRoleForm recordId="0" mode="edit" />
					</PopupButton>,
	        dataIndex: 'jro_id',
	        key: 'jro_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
									baseRoute="/console/job-roles" 
									recordId={record?.jro_id} 
									deleteHandler={doDelete}
									allowEdit={
										authUser?.user_level === 4
											? false
											: (accessRights.edit)
									}
									allowView={accessRights.edit}
									allowDelete={
										authUser?.user_level === 4
											? false
											: (accessRights.delete && record.jro_status_id === 71)
									}
									editMode="modal"
									title="Edit Job Role"
									closeHandler={doRecordReset}
									editHandler={(recordId, doRecordReset ) => (
										<JobRoleForm 
											recordId={recordId} 
											mode="edit" 
											onCancel={doRecordReset} 
										/>
									)}
								/>
	    },
    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.jro_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.jobRole.jobRoleList?.items,
	pagination: state.jobRole.jobRoleList?.pagination,
	filters: state.jobRole.jobRoleList?.filters,
	requesting: state.jobRole.jobRoleList?.requesting,
	error: state.jobRole.jobRoleList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getJobRoleList(filters)),
	doDelete: (id) => dispatch(doJobRoleDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRoleTable);
